export default {
  title: 'Location',
  requestButton: 'Request location',
  askAgain: 'Ask again',
  notPaired: "They'll need the app paired before you can ask for their location.",
  inactive: 'This employee is deactivated.',
  intro: 'Ask for their current location, even when they are away from a site. Nothing is shared unless they accept.',
  modalTitle: 'Request location',
  modalDescription:
    "{name} gets a notification on their phone. Their location is only shared if they accept, and just once, at that moment. The request expires after 30 minutes if they don't answer.",
  reasonLabel: 'Reason (optional)',
  reasonHint: 'Shown to them with the request.',
  reasonPlaceholder: 'e.g. Checking you got to the new site OK',
  send: 'Send request',
  sending: 'Sending…',
  sent: 'Request sent to {name}.',
  cancel: 'Cancel request',
  cancelled: 'Request cancelled.',
  statusPending: 'Waiting',
  statusShared: 'Shared',
  statusDeclined: 'Declined',
  statusCancelled: 'Cancelled',
  statusExpired: 'No answer',
  pendingLine: 'Waiting for {name} to accept. Asked {ago} by {requester}.',
  expiresAt: 'Expires at {time}.',
  sharedLine: 'Shared {ago}, asked by {requester}.',
  declinedLine: '{name} declined {ago}. Asked by {requester}.',
  cancelledLine: 'Cancelled {ago}. Asked by {requester}.',
  expiredLine: "{name} didn't answer within 30 minutes. Asked {ago} by {requester}.",
  reasonLine: 'Reason: {reason}',
  earlier: 'Earlier requests',
  sharedLocation: 'Shared location',
  accuracy: '±{meters}m accuracy',
  openInGoogleMaps: 'Open in Google Maps',
}
